// bao migrate skip
import TabPage from "./../../../factories/tab-page";
import "./../../../services/bao-router";
import "./../../../bindings/bao-toolbar2";
import "./../../../bindings/bao-searcher";
import BaoDialog from "./../../../factories/bao-dialog";
import Bao from "./../../../services/bao-service";
import * as ko from "knockout";
import GenericListSearchTab from "./../../../factories/generic-list-search-tab";
class ChecklistFieldTab extends GenericListSearchTab {
    SearchType(): string {
        return "Checkware-Field";
    }
    ChecklistId: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.ChecklistId = parent;
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
}
export default ChecklistFieldTab;